export default __webpack_public_path__ + "static/media/profile_active.9455338d.svg";